import { Typography, List, ListItem, ListItemIcon, ListItemText, Container } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import '../App.css';

const Imprint = () => {
  return (
    <div className="App">

      <main>

        <Container maxWidth="md" className="container serviceContainer">
          <Typography variant='h1' className='sectionTitle'>Karriere</Typography>

          <Typography variant='h2' className='sectionTitle3'>Studentische Mitarbeitende</Typography>

          <Typography variant='body1' className='sectionText'>
          Ab sofort Studentische Mitarbeitende oder Schülerinnen und Schüler (m/w/d) im Notarbüro Thomas Bensch in Neuruppin gesucht. Die Arbeitszeit ist nach Absprache flexibel einteilbar, gerne auch am Nachmittag/Abend. Auch die wöchentliche Stundenanzahl ist frei nach Ihren Wünschen vereinbar
          </Typography>
          
          <br/>
          <hr />
          <br/>

          <Typography variant='h2' className='sectionTitle3'>Ausbildung als Notarfachangestellte/r (m/w/d)</Typography>

          <Typography variant='body1' className='sectionText'>
          <b>Notar Thomas Bensch · Neuruppin<br />
          zum nächstmöglichen Termin – spätestens zum 1. August 2026</b>
          </Typography>
          <Typography variant='body1' className='sectionText'>
          <b>Der Beruf</b>
          </Typography>
          
          <Typography variant='body1' className='sectionText'>
          Notarfachangestellte sind ein wichtiger Teil unseres Wirtschafts- und Rechtssystems. Sie arbeiten mit dem Notar im Team zusammen und unterstützen Mandanten in verschiedenen Rechtsfragen: 
          </Typography>
          <Typography variant='body1' className='sectionText'>
          Ob Unternehmensgründung, Erwerb eines Hauses, Testament oder Ehevertrag – das Notariat begleitet Menschen bei den wichtigsten Entscheidungen ihres Lebens. Als Notarfachangestellte/r arbeiten Sie weitgehend selbstständig und tragen von Anfang an Verantwortung in einem abwechslungsreichen Arbeitsalltag.
          </Typography>
          <Typography variant='body1' className='sectionText'>
          Viele weitere nützliche Infos zum Berufsbild erhalten Sie unter: <a href="https://www.notarianer.de/" target="_blank">www.notarianer.de</a>
          </Typography>

          <Typography variant='body1' className='sectionText'>
          <b>Was Sie bei uns erwartet</b>
          </Typography>
          <Typography variant='body1' className='sectionText'>
          Als Notarfachangestellte/r in unserem Notariat in Neuruppin:
          </Typography>

          <List>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="betreuen Sie Mandanten und Vertragsbeteiligte persönlich," />
          </ListItem>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="bereiten Sie Verträge und andere Urkunden vor und überwachen deren Vollzug," />
          </ListItem>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="stehen Sie im ständigen Kontakt mit Behörden, Grundbuchämtern, dem Handelsregister und Nachlassgerichten," />
          </ListItem>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="begleiten Sie notarielle Termine von der Vorab-Recherche bis zum abschließenden Schriftverkehr" />
          </ListItem>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="erlernen Sie den Umgang mit moderner Notarsoftware." />
          </ListItem>
        </List><br/>

        <Typography variant='body1' className='sectionText'>
          <b>Ihre persönlichen Stärken</b>
          </Typography>

          <List>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="Sie können sich gut in andere Menschen hineinversetzen." />
          </ListItem>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="Es macht Ihnen Freude, gerechte Lösungen zu finden und damit Streit zu vermeiden." />
          </ListItem>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="Sie haben einen Sinn für Ordnung und Sorgfalt." />
          </ListItem>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="Sie organisieren gern, schmieden Pläne und setzen sie strukturiert um." />
          </ListItem>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="Kommunikation und der Umgang mit Sprache fallen Ihnen leicht" />
          </ListItem>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="Sie interessieren sich für Rechtsfragen." />
          </ListItem>
        </List><br/>



        <Typography variant='body1' className='sectionText'>
          <b>Ihre Ausbildungsvergütung</b>
          </Typography>

          <List>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="1. Lehrjahr 1.250 €" />
          </ListItem>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="2. Lehrjahr 1.300 €" />
          </ListItem>
          <ListItem disablePadding>
              <ListItemIcon>
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary="3. Lehrjahr 1.350 €" />
          </ListItem>
        </List><br/>

        
        <br/>
          <hr />
          <br/>


        <Typography variant='body1' className='sectionText'>
          <b>Ansprechpartner und Bewerbung</b>
          </Typography>


        <Typography variant='body1' className='sectionText'>
        Notar Thomas Bensch<br/>
        Präsidentenstraße 47 · 16816 Neuruppin<br/><br/>
        E-Mail: <a href="mailto:info@bensch-notar.de">info@bensch-notar.de</a> <br/>
        Tel.: 03391 – 458445<br/>
        Fax: 03391 – 458446<br/>
          </Typography>

        <Typography variant='body1' className='sectionText'>
        Sie sind sich noch unsicher? Kein Problem – melden Sie sich einfach bei uns! Wir laden Sie gern zu einem Kennenlerntag ein, damit Sie unser Notariat und das Team persönlich kennenlernen können.
          </Typography>

          <Typography variant='body1' className='sectionText'>
          <b>Wir freuen uns auf Ihre Bewerbung!</b>
          </Typography>
        
        </Container>

      </main >
    </div >
  );
}

export default Imprint;